/**
 * `ResolveAuthResult` — the Home-Realm-Discovery wire shape for the
 * `/internal/resolve-auth` route (HRD-01). The `email → company → IdP` rule
 * lives ONLY in the customer-api route; consumers call the route and read this
 * result, they never re-derive it.
 *
 * Carries ONLY `{ identity_provider, login_hint }`. It MUST never expose
 * company-document internals (HRD over-disclosure threat): the `.parse(...)`
 * strips any extra key. `identity_provider` is best-effort and may be `null`
 * until the source IdP-config field is confirmed (D-US-04).
 */
import { z } from 'zod';

export const ResolveAuthResultSchema = z.object({
  identity_provider: z.string().nullable(),
  login_hint: z.string().nullable(),
});
export type ResolveAuthResult = z.infer<typeof ResolveAuthResultSchema>;
